import styled from "styled-components";

export const ManagePaymentMethodsContainer = styled.div`
  padding: 0 20px;
  padding-top: 35px;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const CloseButton = styled.div`
  position: absolute;
  top: 15px;
  right: 15px;
  cursor: pointer;
`;

export const ManagePaymentMethodsHeader = styled.div`
  display: flex;
  justify-content: center;
`;
export const ManagePaymentMethodsTitle = styled.div`
  color: #002e5c;
  font-size: 20px;
  font-weight: 700;
  line-height: 32px;
`;
export const ManagePaymentMethodsContent = styled.div`
  margin-top: 40px;
  flex: 1;
`;

export const ManagePaymentMethodsFooter = styled.div``;

export const ManagePaymentMethodsActions = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  padding-bottom: 20px;
`;
